import { BaseEntity } from "../base/base-entity";
import { Roles } from "../rbac/rbac";
import { User, UserAuthMethod } from "./user";
import { GroupRole } from "../group/group";

export class UserEntity extends BaseEntity {
  id: string;
  orgId: string;
  accountName: string;
  name: string;
  disabled: boolean;
  roles: Array<Roles>;
  totp?: {
    disabled: boolean;
    enabledAt?: string;
    secret: string;
  } | null;
  groupsRoles: { [key: string]: GroupRole };
  emails: Array<string>;
  authMethod: UserAuthMethod;
  externalUserId?: string;

  constructor(usr: User) {
    super();
    this.id = usr.id;
    this.orgId = usr.orgId;
    this.accountName = usr.accountName;
    this.name = usr.name;
    this.disabled = usr.disabled;
    this.roles = usr.roles;
    this.totp = usr.totp;
    this.groupsRoles = usr.groupsRoles;
    this.emails = usr.emails;
    this.authMethod = usr.authMethod;
    this.externalUserId = usr.externalUserId;
  }

  get groupIDs(): string[] {
    if (!this.groupsRoles) {
      return [];
    }
    return Object.keys(this.groupsRoles);
  }

  get email() {
    if (!this.emails || this.emails.length === 0) {
      return "";
    }
    return this.emails[0];
  }

  isTOTPEnabled(): boolean {
    return !!this.totp && !this.totp.disabled && !!this.totp.enabledAt;
  }

  static fromJSON(json: User) {
    return new UserEntity(json);
  }

  static fromJSONArray(json?: User[]) {
    if (!json) {
      return [];
    }
    return json.map(UserEntity.fromJSON);
  }
}
